import React from 'react';
import fetch from '../../support/fetch';
import { Card, Container, Button, Grid, Form, Page } from 'tabler-react';
import Input from '../../Components/Playgrond/Input';
import Logo from '../../Components/Logo';

import './index.sass';

class Login extends React.Component {

    errors = {
        email: 'E-mail inválido'
    };

    state = {
        showCardAlert: false,
        alertColor: 'danger',
        alertText: '',
        buttonText: 'Autenticar',
        buttonDisabled: false,
        buttonLoading: false,
        login: '',
        password: ''
    };

    componentDidMount() {
        sessionStorage.removeItem("ooppah_user_token");
        sessionStorage.removeItem("ooppah_user_info");
    }

    /**
     * Show/Hide card alert.
     *
     * @param show
     * @param text
     * @param color
     */
    showAlert = (show = true, text, color = 'danger') => {
        this.setState({
            showCardAlert: show,
            alertText: text,
            alertColor: color
        });
    };

    /**
     * Toggle button state.
     * Available values of state: (enable|disabled).
     *
     * @param s
     */
    toggleButtonState = s => {
        let state = {};

        switch (s) {
            case 'enable':
                state = {
                    buttonDisabled: false,
                    buttonLoading: false
                };
                break;
            case 'disable':
                state = {
                    buttonDisabled: true,
                    buttonLoading: true
                };
                break;

            default:
                break;
        }

        this.setState(state);
    };

    /**
     * Input change handler.
     *
     * @param e
     */
    onChangeHandler = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    /**
     * Submit handler.
     *
     * @param e
     */
    onSubmitHandler = e => {
        e.preventDefault();
        this.toggleButtonState('disable');
        this.showAlert(false);

        // authenticate the user...
        this.authenticate();
    };

    /**
     * Try authenticate the user.
     */
    authenticate = () => {
        fetch.obj({
            query: `query AuthSubscriber($login: String!, $password: String!) {
                auth(login: $login, password: $password, context: SUBSCRIBER) {
                    token
                    type
                    expires_at
                }
            }`,
            variables: {
                login: this.state.login,
                password: this.state.password
            }
        })
        .then(res => {
            // check if any error was returned...
            if (res.hasOwnProperty('errors') && res.errors.length > 0) {
                this.showAlert(true, res.errors[0].debugMessage);

                // enable the submit button...
                this.toggleButtonState('enable');

                return;
            }

            // authentication occur with success. Continue...
            if (res.data.auth && res.data.auth.hasOwnProperty('token')) {
                sessionStorage.setItem("ooppah_user_token", JSON.stringify(res.data.auth));
                this.showAlert(true, "Autenticado. Preparando seu dashboard...", "success");
                this.collectUserDataAndRedirect(res.data.auth);
                return;
            }

            this.showAlert(true, 'Unknown error');
        });
    };

    collectUserDataAndRedirect = (tokenInfo) => {
        fetch.initialize().obj({
            query: `
            query FetchSubscriberInfo {
                subscriber {
                    initials
                    name
                    activated
                    isMinor
                    document
                    email
                    phone
                    guardian {
                      name
                      birthday
                      document
                      documentIssuer
                      documentShippingDate
                    }
                    address {
                      street
                      number
                      complement
                      district
                      city
                      state
                      zipCode
                    }
                }
            }`
        })
        .then(res => {
            if (res.hasOwnProperty('errors')) {
                this.setState({
                    alertText: res.errors[0].debugMessage,
                    alertColor:  'danger',
                    showCardAlert: true,
                    buttonLoading: false,
                    buttonDisabled: false
                });

                return;
            }

            // store the authenticated user info...
            sessionStorage.setItem("ooppah_user_info", JSON.stringify(res.data.subscriber));

            // redirect user to your dashboard...
            window.location = '/home';

            // enable the submit button...
            this.toggleButtonState('enable');
        });
    };

    render() {
        return (
            <Page>
                <Container>
                    <Grid.Row>
                        <Grid.Col className="col-login mx-auto login">
                            <form onSubmit={this.onSubmitHandler} autoComplete="off">
                                <Logo />

                                <h3 className="text-center">Sistema do Assinante</h3>

                                <Card>
                                    <Card.Body>
                                        <p className = 'text-apresentation'> 
                                            Esta área é exclusiva para gerenciar seus pagamentos, 
                                            cartões de crédito, alterar senhas e endereços, renovações de planos e cancelamentos.
                                            Para acessar seu perfil de artista acesse <a href="https://profile.ooppah.com">profile.ooppah.com</a>
                                        </p>
                                    </Card.Body>
                                </Card>

                                <Card>
                                    {
                                        this.state.showCardAlert &&
                                        <Card.Alert color={this.state.alertColor}>{this.state.alertText}</Card.Alert>
                                    }

                                    <Card.Body>
                                        
                                        <Form.Group label="CPF">
                                            <Input
                                                name="login"
                                                type="tel"
                                                onChange={this.onChangeHandler}
                                                numberOnly={true}
                                                maxLength={11}
                                            />
                                        </Form.Group>

                                        <Form.Group label="Senha">
                                            <Input name="password" type="password" onChange={this.onChangeHandler} />
                                        </Form.Group>

                                        <Button
                                            block
                                            loading={this.state.buttonLoading}
                                            disabled={this.state.buttonDisabled}
                                            color="primary">{this.state.buttonText}</Button>
                                            
                                            
                                    </Card.Body>
                                </Card>

                                <a
                                    href="/forgot-password"
                                    className="text-center small d-block"
                                    >Esqueci minha senha</a>
                            </form>
                        </Grid.Col>
                    </Grid.Row>
                </Container>
            </Page>
        );
    }
}

export default Login;